import { sortBy } from 'lodash/fp';
import { AgeGroupEntity } from 'types';

import _ from '../locale';

export const getAgeGroupsRange = (ageGroupIds: number[], ageGroupEntities: AgeGroupEntity[]) => {
    if (!(ageGroupIds && ageGroupIds.length)) {
        return '';
    }

    if (ageGroupIds.length === 1) {
        return _(`age_group_${ageGroupIds[0]}`);
    }

    const sortedAgeGroups = sortBy(
        ['min_age_time_unit', 'min_age'],
        ageGroupEntities
            .filter(({ id }) => ageGroupIds.includes(id))
            .map(({ min_age, ...restProps }) => ({
                ...restProps,
                min_age: min_age || 0,
            }))
    );

    const minAgeGroup = sortedAgeGroups[0];
    const minAge = `${minAgeGroup.min_age} (${minAgeGroup.min_age_time_unit}s)`;

    const maxAgeGroup = sortedAgeGroups[sortedAgeGroups.length - 1];
    const maxAge =
        (maxAgeGroup.max_age || `${maxAgeGroup.min_age}+`) + ` (${maxAgeGroup.max_age_time_unit}s)`;

    return `${minAge} - ${maxAge}`;
};

export const getWholeAgeRange = (
    ages5years: number[],
    ageGroupIds: number[],
    ageGroupEntities: AgeGroupEntity[]
): number[] => {
    const timeUnit = 'year';

    const allAgeGroups = ageGroupEntities.filter(({ id }) => ageGroupIds.includes(id));
    const age5YearsGroups = ageGroupEntities.filter(({ id }) => ages5years.includes(id));

    return allAgeGroups
        .filter((itemAll) => {
            const { id, max_age_time_unit, min_age_time_unit, min_age, max_age } = itemAll;
            return (
                max_age_time_unit === timeUnit &&
                min_age_time_unit === timeUnit &&
                age5YearsGroups.every((item5) => {
                    return (
                        (id !== item5.id &&
                            min_age !== item5.min_age &&
                            max_age !== item5.max_age &&
                            max_age !== item5.min_age &&
                            min_age !== item5.max_age) ||
                        ages5years.includes(id)
                    );
                })
            );
        })
        .map(({ id }) => id);
};
